export const BKS_DOCUMENT_IMPORT_MAPPINGS_SETTING_NAME = 'BKS_DOCUMENT_IMPORT_MAPPINGS';

export interface BKSConnectionMapping {
    external_business_id: string;
    external_business_name: string | null;
    journal_ids: string[];
    schedule_enabled: boolean;
}

export type BKSDocumentImportMappings = Record<string, BKSConnectionMapping>;

export interface BKSImportParams {
    administrationId: string;
    administrationName?: string | null;
    journals: string[];
    startDate: string;
    endDate: string;
    connectionId: string;
}

export interface BKSEntrepreneurBusiness {
    id: string;
    name: string;
    selected?: boolean | null;
    vat?: string | null;
    company_number?: string | null;
}

export interface BKSJournal {
    id: string;
    name: string;
    journal_type?: string;
    type?: string;
    code?: string | null;
    currency?: string | null;
}

export interface BKSImportJobSummary {
    import_id: string;
    status: string;
    connection_id: string;
    connection_name: string | null;
    date_from: string;
    date_to: string;
    created_at: string;
    error_context: object | null;
}

export interface BKSImportStatusResponse {
    import_id: string;
    business_id: string;
    status: string;
    total_documents: number;
    processed_documents: number;
    failed_documents: number;
    created_at: string;
    started_at: string | null;
    processed_at: string | null;
    failed_at: string | null;
    error_context: object | null;
    failed_document_details: Array<{
        document_id?: string | null;
        invoice_id?: string | null;
        error?: string;
    }> | null;
}

export interface InitiateBKSImportResult {
    import_id: string;
    status: string;
}
export function formatBKSImportErrorContext(errorContext: object | null | undefined): string | null {
    if (!errorContext || typeof errorContext !== 'object') {
        return null;
    }

    const record = errorContext as Record<string, unknown>;
    if (typeof record.error === 'string' && record.error.trim()) {
        return record.error;
    }
    if (typeof record.message === 'string' && record.message.trim()) {
        return record.message;
    }

    try {
        return JSON.stringify(errorContext);
    } catch {
        return null;
    }
}

export const BKS_IMPORT_JOB_ERROR_FALLBACK = 'Geen foutdetails beschikbaar.';

export function resolveBKSImportJobErrorMessage(
    errorContext: object | null | undefined,
    summaryErrorContext?: object | null,
): string {
    return formatBKSImportErrorContext(errorContext)
        ?? formatBKSImportErrorContext(summaryErrorContext)
        ?? BKS_IMPORT_JOB_ERROR_FALLBACK;
}
